'use client'
import Typography from '@components/common/Typography'
import Image, {StaticImageData} from 'next/image'
import Button from '@components/common/Button'
import MasseraLogo from '@images/massera-logo.png'
import ChevronRightFill from '@svg/chevronRightFill.svg'
import RadialGradientBlur from '@components/common/RadialGradientBlur'
import Link from 'next/link'

interface Card {
  imageSrc: StaticImageData
  imgWidth?: number
  title: string
  description: string
  link: string
}

function Technology() {
  const cards: Card[] = [
    {
      imageSrc: MasseraLogo,
      title: 'Cross-Border Liquidity Provider',
      description:
        'Cross-border payment processor and liquidity provider that facilitates international settlements  through secure banking rails and supports fiat conversions for digital asset ecosystems.',
      link: 'https://mazzera.finance/',
    },
  ]

  return (
    <div className="flex flex-col gap-20 relative w-full">
      <RadialGradientBlur />
      <Typography size="xl" className="text-center">
        The Underlying Technology
      </Typography>
      <div className="flex flex-col gap-6">
        <div id="technology-scrollable" className="flex flex-nowrap gap-6 h-full overflow-x-auto no-scrollbar">
          {cards.map((card, index) => (
            <Card key={index} {...card} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default Technology

const Card = (card: Card) => {
  return (
    <div className="flex flex-col min-w-[350px] max-w-[450px] border border-soft-200 rounded-2xl bg-soft-100 py-6 px-3">
      <div className="mb-auto" style={{width: card.imgWidth ?? 320 + 'px', height: '120px'}}>
        <Image
          src={card.imageSrc}
          alt={card.title}
          width={card.imgWidth ?? 320}
          height={120}
          className={`w-full h-[120px] object-contain`}
          style={{
            width: '100%',
            height: '100%',
            maxWidth: '320px',
            maxHeight: '120px',
          }}
        />
      </div>
      <div className="flex flex-col flex-1 gap-2.5 px-3 py-6">
        <Typography size="lg2">{card.title}</Typography>
        <Typography size="md2" className="flex-1">
          {card.description}
        </Typography>
        <Link href={card.link} target="_blank" rel="noopener noreferrer">
          <Button variant="plain" postIcon={<ChevronRightFill />} className="w-fit ml-auto hover:bg-[#211d2d]">
            Learn More
          </Button>
        </Link>
      </div>
    </div>
  )
}
